import { useGameStore } from '../game/store';

export function GameOverScreen(): JSX.Element | null {
  const last = useGameStore((s) => s.lastGameOver);
  const settings = useGameStore((s) => s.settings);
  const quitGame = useGameStore((s) => s.quitGame);

  if (!last) return null;
  return (
    <div className="overlay">
      <div className="overlay-card">
        <h2>Game Over</h2>
        <div className="big-score">{last.score}</div>
        {last.newHighScore && <div className="new-record">★ New High Score ★</div>}
        <div className="stats-row">
          <div>Length <strong>{last.snakeLength || settings.longestRun}</strong></div>
          <div>Best <strong>{settings.highScore}</strong></div>
        </div>
        <button className="primary" onClick={quitGame}>Back to Menu</button>
        <button className="primary" onClick={() => window.location.reload()}>Play Again</button>
      </div>
    </div>
  );
}
